import { useTranslation } from 'react-i18next';
import React from 'react';
import MapImage from '../common/MapImage';

/**
 * Recent matches list for player profile.
 */
export default function RecentMatchesSection({ matches, onSelectMatch }) {
  const { t } = useTranslation();
  if (!matches || matches.length === 0) return null;

  return (
    <div className="stats-section">
      <h3>📅 {t('profile.recentMatches')}</h3>
      <div className="recent-matches-list">
        {matches.map((match, idx) => (
          <div
            key={idx}
            className="recent-match-row clickable"
            onClick={() => onSelectMatch && onSelectMatch(match.matchid)}
          >
            <div className="recent-match-map-info">
              {match.image_url && (
                <div className="recent-match-map-thumb">
                  <MapImage imageUrl={match.image_url} mapName={match.mapname} className="thumb" />
                </div>
              )}
              <span className="match-map">{match.mapname}</span>
            </div>
            <span className="match-score">
              {match.team === match.team1_name ? match.team1_score : match.team2_score}
              -
              {match.team === match.team1_name ? match.team2_score : match.team1_score}
            </span>
            <span className="match-kda">{match.kills}/{match.deaths}/{match.assists}</span>
            <span className="match-date">{new Date(match.start_time).toLocaleDateString('sv-SE')}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
